export const REDUX_SET = '/redux/container/DocBundleManagerContainer/set';
export const REDUX_RESET = '/redux/container/DocBundleManagerContainer/reset';
